module.exports = __webpack_public_path__ + "img/f2.0a8e5294.svg";